import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import * as PT from './extractedTranslations/pt/translation.json';
import * as EN from './extractedTranslations/en/translation.json';
import * as ES from './extractedTranslations/es/translation.json';
import * as DE from './extractedTranslations/de/translation.json';
import * as FR from './extractedTranslations/fr/translation.json';
import * as ID from './extractedTranslations/id/translation.json';
import * as IT from './extractedTranslations/it/translation.json';
import * as JA from './extractedTranslations/ja/translation.json';
import * as KO from './extractedTranslations/ko/translation.json';
import * as TH from './extractedTranslations/th/translation.json';
import * as VI from './extractedTranslations/vi/translation.json';
import * as ZH from './extractedTranslations/zh-hans/translation.json';

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: EN },
    de: { translation: DE },
    es: { translation: ES },
    fr: { translation: FR },
    id: { translation: ID },
    it: { translation: IT },
    ja: { translation: JA },
    ko: { translation: KO },
    pt: { translation: PT },
    th: { translation: TH },
    vi: { translation: VI },
    zh: { translation: ZH },
    'zh-hans': { translation: ZH },
    'zh-cn': { translation: ZH },
  },
  fallbackLng: 'en',
  lng: 'en',
  ns: ['translation'],
  defaultNS: 'translation',
  // allow translation keys to contain ':' character
  nsSeparator: false,
  keySeparator: false,
  initImmediate: true,
  interpolation: {
    escapeValue: false,
    formatSeparator: ',',
  },
});

export default i18n;
